import { render, staticRenderFns } from "./BuyerCountryNotAllowed.vue?vue&type=template&id=1217c053&scoped=true&"
import script from "./BuyerCountryNotAllowed.vue?vue&type=script&lang=js&"
export * from "./BuyerCountryNotAllowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1217c053",
  null
  
)

export default component.exports